function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class GraphQLRequestClient {
  constructor(client) {
    _defineProperty(this, "client", void 0);
    this.client = client;
  }
  async query({
    query,
    variables,
    headers,
    namespace
  }) {
    let response = await this.client.request(query, variables, headers);
    return namespace && response ? response[namespace] : response;
  }
  async mutate({
    mutation,
    variables,
    headers,
    namespace
  }) {
    let response = await this.client.request(mutation, variables, headers);
    return namespace && response ? response[namespace] : response;
  }
}
export default GraphQLRequestClient;